<span [ngClass]="badgeClasses">
  <mat-icon *ngIf="icon" class="data-table-badge__icon">{{ icon }}</mat-icon>
  <span>{{ label }}</span>
</span>
